import Masonry from "masonry-layout"
import imagesLoaded from 'imagesloaded';
import TAGGED from "../modules/tagged_content"

const [ w, d, l, content ] = [ window, document, location, 'works' ]

// 詳細ページにて実行
const detail_init = async post_id => {
  let articles = await $.getArticles({ content, post_status: 'all' })
  let categories = await $.getCategories({ content })
  let the_article = articles.filter( a => (a.id == post_id) ).shift()
  the_article.category = categories.filter( c => c.id == the_article.category )[0]

  // タグボックス
  let tags = keywords => {
    let html = ""
    if(!keywords || keywords.length == 0) return ''
    keywords.forEach( key => html += `<a href="/${content}/?mode=list&tag=${ encodeURI( key ) }" class="tag">#${key}</a>` )
    return `<div class="${content}-detail__tags">${html}</div>`
  }

  // 詳細置き換え
  $('.element_detail').each( ( i, elm_detail ) => {
    let $head = $(`
      <div class="${content}-detail__head">
        ${the_article.category ? `<span class="cat">【${the_article.category.name}】</span>`: '' }
        <div class="visible-xsmall">
          <h3 class="title">${the_article.title}</h3>
          ${the_article.desc.length ? `<p class="desc">${the_article.desc}</p>`: '' }
        </div>
      </div>
    `)
    $('.element_detail > .title, .detail_title').remove()

    $head.prependTo( elm_detail )

    $('.element_detail .entry').append( tags( the_article.keywords ) )

  });

}


export default function WORKS () {

  // 一覧ページのテンプレート(Vue template)
  const itemTemplate = `
    <div id="main" class="column-3-4">
      <transition-group class="${content}-list" tag="ul" name="fade" mode="out-in" :class="[ 'is-paged-' + paged ]">
        <li class="${content}-item" v-for="article in infiniteArticles" :key="article.id">
          <a class="${content}-item__link" :href="article.href" @click.prevent="openModal(article)">
            <figure class="${content}-item__img">
              <div class="${content}-item__img-cover" :style="'background-image:url(' + article.thumb + ')'">
                <img :src="article.thumb" width="220">
              </div>
              <svg class="cover" width="100%" height="100%">
                <circle class="front-hover" cx="0" cy="0" r="0"></circle>
              </svg>
            </figure>
            <div class="${content}-item__body">
              <span class="subject" :class="{'is-new' : article.is_new}">
                {{ article.title }}
              </span>
            </div>
          </a>
          <div class="works-item__foot">
            <span class="cate"><i class="fa fa-tag"></i><a :href="article.category.href">{{article.category.name}}</a></span>
            <span class="tags" v-if="article.keywords != null">
              <a :href="'/${content}/?mode=list&tag='+encodeURI(tag)" class="tag" v-for="tag in article.keywords.slice(0,3)">#{{tag}}</a>
            </span>
          </div>
        </li>
      </transition-group>
      <infinite-scroll
        v-if="totalPage > 1"
        :paged="paged"
        :total-page="totalPage"
        :total-item="totalItem"
        :item-count="infiniteArticles.length"
        @getPage="getPage"
      ></infinite-scroll>
      <detailModal
        :article="modalArticle"
        :related="modalRelated"
        :prevPostID="getPrevPost(modalArticle.id)"
        :nextPostID="getNextPost(modalArticle.id)"
        :changeModal="changeModal"
        v-show="showModal"
        @close="closeModal"
        @prev="changeModal( getPrevPost(modalArticle.id) )"
        @next="changeModal( getNextPost(modalArticle.id) )"
        @getRelated="getRelated"
      />
    </div>
  `

  // カテゴリ一覧ページにて、記事ごとの要素置き換え
  const replaceItemTemplate = item => `
    <li class="${content}-item">
      <a class="${content}-item__link" href="${item.href}">
        <figure class="${content}-item__img">
          <div class="${content}-item__img-cover" style="background-image:url( ${item.thumb} )">
            <img src="${item.thumb}" width="200">
          </div>
        </figure>
        <div class="${content}-item__body">
          <div class="${content}-item__title">
            <span class="subject">
              ${item.title.str_truncate( 20 )}
              ${item.is_new ? '<span class="new">NEW</span>': ''}
            </span>
            <span class="desc">
              ${item.desc.str_truncate( 40 )}
            </span>
          </div>
        </div>
      </a>
    </li>
  `

  // 関連記事のテンプレート(Vue template)
  const relatedItemTemplate = `<div class="d-none" />`;

  // 詳細モーダルのテンプレート(Vue)
  const detailModal = {
    name: 'detailModal',
    props: [ 'article', 'related', 'prevPostID', 'nextPostID', 'changeModal' ],
    computed:{
      casebody () {
        let $res = '';
        let $body = $(`<div class="body__wrap" />`).html( this.article.body );
        if( this.article.body ){
          $('[data-aside],.works-dtp__table', $body).remove();
          $res = $body[0].outerHTML;
        }
        return $res;
      },
      aside () {
        let $res = '';
        let $body = $(`<div class="body__wrap" />`).html( this.article.body );
        if( this.article.body && $('[data-aside],.works-dtp__table', $body).length ){
          $res = $('<div class="works-aside__inner" />');
          $res.append( $('[data-aside],.works-dtp__table', $body) );
          $res = $res[0].outerHTML;
        }
        return $res;
      }
    },
    mounted () {
    },
    template: `
      <transition name="modal">
        <div class="modal modal-overlay" @click.self="$emit('close')">
          <div class="modal-container works-detail-modal__container">
            <button type="button" @click="$emit('close')" class="modal-container__closebtn"><svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31.29 31.29"><circle style="fill:#c3c3c3" cx="15.65" cy="15.65" r="15.65"/><line style="fill:none;stroke:#fff;stroke-miterlimit:10;" x1="11.81" y1="11.81" x2="19.48" y2="19.48"/><line style="fill:none;stroke:#fff;stroke-miterlimit:10;" x1="19.48" y1="11.81" x2="11.81" y2="19.48"/></svg></button>
            <button type="button" @click="$emit('prev')" class="modal-container__prevbtn" :disabled="!prevPostID"><svg width="20" height="33.5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.43 33.52"><path style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;" d="M18.93,32,1.5,16.76,18.93,1.5"/></svg></button>
            <button type="button" @click="$emit('next')" class="modal-container__nextbtn" :disabled="!nextPostID"><svg width="20" height="33.5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.43 33.52"><path style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;" d="M1.5,1.5,18.93,16.76,1.5,32"/></svg></button>
            <div class="modal-body works-detail-modal">
              <div class="works-detail">
                <div class="works-detail__head">
                  <h3 class="subject">{{ article.title }}</h3>
                  <span class="cate" v-if="article.category != null"><i class="fa fa-tag"></i><a :href="article.category.href">{{article.category.name}}</a></span>
                  <span class="tags" v-if="article.keywords != null">
                    <a :href="'/${content}/?mode=list&tag='+encodeURI(tag)" class="tag" v-for="tag in article.keywords">#{{tag}}</a>
                  </span>
                </div>
                <div class="body" v-html="casebody"></div>
              </div>
              <!-- /.works-detail -->
              <aside class="works-aside" v-html="aside" />
              <!-- /.works-detail -->
              <div class="paginationbox visible-xsmall">
                <div class="pageNav">
                  <a href="javascript:void(0)" @click="$emit('prev')" class="prev" :class="{'disable': !prevPostID}">Prev</a>
                  <div class="backbtn">
                    <a href="javascript:void(0)" @click.prepend="$emit('close')">LIST</a>
                  </div>
                  <a href="javascript:void(0)" @click="$emit('next')" class="next">Next</a>
                </div>
                <!-- /.pageNav -->
              </div>
              <detailRelated
                v-if="(related.length > 0)"
                :tags="article.keywords"
                :related="related"
                :changeModal="changeModal"
              />
              <!-- /.works-detail -->
            </div>
          </div>
        </div>
      </transition>
    `
  }

  const detailRelated = {
    name: 'detailRelated',
    props:['tags','related','changeModal'],
    template: `
      <div class="works-related">
        <h3 class="works-related__title">関連事例</h3>
        <ul class="works-related__list" ref="worksRelatedList">
          <li class="${content}-item" v-for="article in related" :key="article.id">
            <a class="${content}-item__link" :href="article.href" @click.prevent="changeModal( article.id )">
              <figure class="${content}-item__img">
                <div class="${content}-item__img-cover" :style="'background-image:url(' + article.thumb + ')'">
                  <img :src="article.thumb" width="220">
                </div>
                <svg class="cover" width="100%" height="100%">
                  <circle class="front-hover" cx="0" cy="0" r="0"></circle>
                </svg>
              </figure>
              <div class="${content}-item__body">
                <span class="subject" :class="{'is-new' : article.is_new}">
                  {{ article.title }}
                </span>
              </div>
            </a>
            <div class="works-item__foot">
              <span class="cate"><i class="fa fa-tag"></i><a :href="article.category.href">{{article.category.name}}</a></span>
              <span class="tags" v-if="article.keywords != null">
                <a :href="'/${content}/?mode=list&tag='+encodeURI(tag)" class="tag" v-for="tag in article.keywords.slice(0,3)">#{{tag}}</a>
              </span>
            </div>
          </li>
        </ul>
      </div>
    `
  }


  const itemHoverSvg = (i,v) => {
    let hoverObj = v.querySelector('circle.front-hover');
    v.addEventListener('mouseenter', e => {
      hoverObj.setAttribute( 'cx', e.offsetX );
      hoverObj.setAttribute( 'cy', e.offsetY );
      hoverObj.setAttribute( 'r', '865' );
    });
    v.addEventListener('mouseleave', e => {
      hoverObj.setAttribute( 'r', '0' );
    })
  }

  TAGGED({
    perpage: 30,
    related: 6,
    taglist_disp_list: true, // head / foot / both
    taglist_disp_detail: false, // head / foot / both
    taglist_minimumTagAmount : 10, // タグの最低表示数
    taglist_hideUselessTags : 12, // 最低使用回数
    itemTemplate,
    replaceItemTemplate,
    relatedItemTemplate,
    addData:{
      modalArticle: {},
      modalRelated: {},
      showModal: false,
      listUrl: l.pathname,
    },
    addMethods: {
      openModal (article) {
        this.modalArticle = article;
        this.showModal = true;
        $('html').addClass('is-activeModal');
        this.getRelated();

        // DOM更新されたら実行
        this.$nextTick(() => {
          // スクロールリセット
          d.querySelector('.modal-container').scrollTop = 0;

          // 関連記事
          var relatedList = d.querySelector('.works-relatedList__list');
          if( relatedList ){
            imagesLoaded( relatedList, () => {
              $('svg.cover', '.works-related__list .works-item').each( itemHoverSvg );
            });
          }

          const canonical = d.querySelector('link[rel="canonical"]');
          const canonicalUrl = l.origin + article.href;
          canonical.setAttribute('href', canonicalUrl);

          //アドレスバーを記事URLに書き換える
          let currentPage = l.pathname+l.search;
          if ( article.href !== currentPage ) {
            history.pushState(null, null, article.href);
          }

        });
      },

      closeModal () {
        this.showModal = false;
        $('html').removeClass('is-activeModal');

        //アドレスバーを一覧URLに書き換える
        history.replaceState(null, null, this.listUrl);

        const canonical = d.querySelector('link[rel="canonical"]');
        canonical.setAttribute('href', l.href);

      },
      getNextPost (current) {
        let next,nextInd;
        this.filterArticles().find( (v,i) => {
          if( v.id == current ) nextInd = i + 1;
        });
        next = (this.filterArticles()[nextInd])? this.filterArticles()[nextInd].id : false ;
        return next;
      },
      getPrevPost (current) {
        let prev,prevInd;
        this.filterArticles().find( (v,i) => {
          if( v.id == current ) prevInd = i - 1;
        });
        prev = (this.filterArticles()[prevInd])? this.filterArticles()[prevInd].id : false ;
        return prev;
      },
      changeModal (id) {
        if( id ){
          let article = this.articles.find( v => v.id == id );
          $('.modal-body').fadeOut(200, () => {
            // スクロールリセット
            d.querySelector('.modal-container').scrollTop = 0;
            this.modalArticle = article;
            this.getRelated();
            this.$nextTick( () => {
              // 関連記事
              var relatedList = d.querySelector('.works-related__list');
              if( relatedList ){
                imagesLoaded( relatedList, () => {
                  $('svg.cover', '.works-related__list .works-item').each( itemHoverSvg );
                });
              }

              const canonical = d.querySelector('link[rel="canonical"]');
              const canonicalUrl = l.origin + article.href;
              canonical.setAttribute('href', canonicalUrl);

              //アドレスバーを記事URLに書き換える
              history.replaceState(null, null, article.href);
            });
            $('.modal-body').fadeIn(200);
          });

        }
      },
      getRelated () {
        const this_tags = this.modalArticle.keywords;

        this.modalRelated = this.articles.filter( item => {
          if( item.id == this.modalArticle.id ) return false
          let related_tags = [...new Set( item.keywords )]
            .filter( tag => {
                if( this_tags != null && this_tags.length ) return this_tags.includes( tag )
              })
              return related_tags && related_tags.length >= 1
            })
            .slice( 0, 6 );
      }
    },
    addMounted( vueObj ) {

      //一覧URLを格納
      if( /mode=list/.test( l.search ) ) {
        vueObj.listUrl = l.pathname + l.search;
      }

      //記事ページの場合はモーダル開く
      if( /article=[\d]+/.test( l.search ) ) {
        const id = l.search.match(/article=(\d+)/)[1];
        const article = vueObj.filterArticles().find( v => v.id == id );
        vueObj.openModal( article );
      }

      //ブラウザの戻る・進むで移動した時
      w.addEventListener('popstate', () => {
        //移動先が一覧の場合 モーダルを閉じる
        if( /mode=list/.test( l.search ) || l.search == '' && vueObj.showModal == true ) {
          vueObj.closeModal();
        }

        //移動先が記事の場合 モーダルを開くか記事を変更する
        if( /article=[\d]+/.test( l.search ) ) {
          const id = l.search.match(/article=(\d+)/)[1];
          const article = vueObj.filterArticles().find( v => v.id == id );
          (vueObj.showModal == true) ? vueObj.changeModal( id ) : vueObj.openModal( article );
        }
      });

    },
    addComponent: [
      detailModal,
      detailRelated
    ],
    callback()　{

      $('svg.cover', '.works-list .works-item').each( itemHoverSvg );

      const elem = d.querySelector('.works-list');
      let masonry;
      // layout Masonry after each image loads
      imagesLoaded( elem, () => {
        masonry = new Masonry( elem, {
          itemSelector: '.works-item',

        });
      });

      d.addEventListener('tagsort.getPage', () => {
        const elem = d.querySelector('.works-list');
        masonry.reloadItems();
        masonry.layout();
        imagesLoaded( elem, () => {
          masonry.layout();
          $('svg.cover', '.works-list .works-item').each( itemHoverSvg );
        });
      });

    }
  })
  $(() => {
    if( w.query_string('article') ) detail_init( w.query_string('article') )
  })
}